/* eslint-disable */
import { PayRuleTable } from 'components/table/pay_rules/PayRulesTable';

const PayRules = () => {

    return (
        <>
            <PayRuleTable/>
        </>
    )
}

export { PayRules }